import { render, staticRenderFns } from "./JobAssignmentOrderDelete.vue?vue&type=template&id=71f5b1f0&scoped=true&"
import script from "./JobAssignmentOrderDelete.vue?vue&type=script&lang=js&"
export * from "./JobAssignmentOrderDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f5b1f0",
  null
  
)

export default component.exports